import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const EditSupplierPayment = ({ itemId, handleClose, show }) => {
  const [paymenttype, setPaymenttype] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (!itemId) return;

    axios
      .get(`/supplier-balances/edit-supplier-payment/${itemId}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let editData = response.data.data.payment;
          editData.amount = editData.cost;
          setFormData(editData);

          if (editData.operation === 2 || editData.operation === 3) {
            setPaymenttype([
              { id: 1, text: "Bank Transfer" },
              { id: 2, text: "Cash" },
              { id: 3, text: "Cheque" },
            ]);
          }
        }
      })
      .catch((error) => console.log(error));
  }, [itemId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Remove backend error for the field
    setBackendErrors((prevErrors) => {
      let newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/supplier-balances/update-payment", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.href = `/supplier-balances-detail/${formData.supplier}`;
          }, 500);
        } else {
          setBackendErrors(response.data.error || {});
        }
      })
      .catch((error) => console.log(error));
  };

  const handleOperationChange = (e) => {
    const value = e.target.value;
    handleChange(e);

    if (value === "2" || value === "3") {
      setPaymenttype([
        { id: 1, text: "Bank Transfer" },
        { id: 2, text: "Cash" },
        { id: 3, text: "Cheque" },
      ]);
    } else {
      setPaymenttype([]);
    }
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header>
        <h4 className="modal-title">Edit Supplier Payment</h4>
        <button type="button" className="close" data-bs-dismiss="modal" onClick={handleClose}>&times;</button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          {backendSuccess && <div className="from-success mt-1">{backendSuccess}</div>}

          <div className="form-group">
            <label>Date</label>
            <input
              className="form-control"
              type="date"
              name="date"
              value={formData.date || ""}
              onChange={handleChange}
            />
            {backendErrors.date && <small className="form-error">{backendErrors.date}</small>}
          </div>

          <div className="form-group">
            <label>Amount</label>
            <input
              className="form-control"
              type="text"
              name="amount"
              value={formData.amount || ""}
              onChange={handleChange}
              onKeyPress={(event) => {
                if (!/^\d*\.?\d*$/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
            {backendErrors.amount && <small className="form-error">{backendErrors.amount}</small>}
          </div>

          <div className="form-group">
            <label>Select Operation</label>
            <select
              className="form-control"
              name="operation"
              value={formData.operation || ""}
              onChange={handleOperationChange}
            >
              <option value="">Select</option>
              <option value="1">Solde</option>
              <option value="2">Avance</option>
              <option value="3">Payment</option>
            </select>
            {backendErrors.operation && <small className="form-error">{backendErrors.operation}</small>}
          </div>

          {paymenttype.length > 0 && (
            <div className="form-group">
              <label>Select Payment Type</label>
              <select
                className="form-control"
                name="payment_type"
                value={formData.payment_type || ""}
                onChange={handleChange}
              >
                <option value="">Select</option>
                {paymenttype.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.text}
                  </option>
                ))}
              </select>
              {backendErrors.payment_type && <small className="form-error">{backendErrors.payment_type}</small>}
            </div>
          )}

          <div className="form-group">
            <label>Note</label>
            <textarea
              className="form-control"
              name="note"
              value={formData.note || ""}
              onChange={handleChange}
            />
            {backendErrors.note && <small className="form-error">{backendErrors.note}</small>}
          </div>

          <div className="submit-section">
            <button type="submit" className="btn btn-primary submit-btn">
              UPDATE
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
EditSupplierPayment.propTypes = {
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Accepts string or number
  handleClose: PropTypes.func.isRequired, // Must be a function
  show: PropTypes.bool.isRequired, // Must be a boolean
};
export default EditSupplierPayment;

